module.exports = __webpack_public_path__ + "img/success.94395dea.svg";